module.exports = __webpack_public_path__ + "img/more_hover.2c8194d2.svg";